module.exports = __webpack_public_path__ + "assets/img/C-571bb319.jpg";